import React from 'react';
import { DialogActions, Button } from '@mui/material';

interface DialogActionButtonsProps {
    isLoading: boolean;
    onCancel: () => void;
    onSave: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
    isLoading,
    onCancel,
    onSave
}) => {
    return (
        <DialogActions>
            <Button onClick={onCancel} disabled={isLoading}>
                Cancel
            </Button>
            <Button
                onClick={onSave}
                variant="contained"
                disabled={isLoading}
            >
                {isLoading ? 'Creating...' : 'Create'}
            </Button>
        </DialogActions>
    );
};
